import { Controller } from 'stimulus'

import { BREAKPOINTS } from '../../_js/base/consts'

export default class PrototypePage extends Controller {
  static targets = ['svg', 'horizontalTemplate', 'verticalTemplate', 'iframeContainer']

  static getScrollTop = function () {
    return window.scrollY || (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
  }

  static getScrollLeft = function () {
    return (
      window.scrollX || (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft
    )
  }

  connect() {
    this.pageLoaded = false
    window.addEventListener('load', () => {
      this.pageLoaded = true
      this.render()
    })
  }

  drawLine(id, type = 'horizontal', startX, startY, endX, endY, toggleVisibility = false) {
    let line = document.getElementById(id)
    if (!line) {
      line = this[`${type}TemplateTarget`].cloneNode(true)
      line.removeAttribute('data-prototype-target')
      line.id = id
      line.setAttribute('class', 'prototype-arrow')
      this.svgTarget.appendChild(line)
    }

    const start = line.querySelector('.prototype-arrow__start')
    start.setAttribute('transform', `translate(${startX}, ${startY})`)

    const end = line.querySelector('.prototype-arrow__end')
    end.setAttribute('transform', `translate(${endX}, ${endY})`)

    // draw line
    const lineWidth = endX - startX
    const lineHeight = endY - startY
    const lineStartOffsetLeft = type === 'horizontal' ? 3 : 0
    const lineStartOffsetTop = type === 'horizontal' ? 0 : 3
    const lineEndOffsetLeft = type === 'horizontal' ? -7 : 0
    const lineEndOffsetTop = type === 'horizontal' ? 0 : -1
    line
      .querySelector('.prototype-arrow__line')
      .setAttribute(
        'd',
        type === 'horizontal'
          ? `m${startX + lineStartOffsetLeft},${startY + lineStartOffsetTop} c${lineWidth / 2},0 ${
              lineWidth / 2
            },${lineHeight} ${lineWidth + lineEndOffsetLeft},${lineHeight + lineEndOffsetTop}`
          : `m${startX + lineStartOffsetLeft},${startY + lineStartOffsetTop} c0,${lineHeight / 2} ${lineWidth},${
              lineHeight / 2
            } ${lineWidth + lineEndOffsetLeft},${lineHeight + lineEndOffsetTop}`
      )

    line.classList.toggle('is-hidden', toggleVisibility)
  }

  drawEvenSectionLines(startId, sectionIndex) {
    const scrollLeft = PrototypePage.getScrollLeft()
    const scrollTop = PrototypePage.getScrollTop()

    for (let i = 0; i < 3; i++) {
      const hlineStartRect = document
        .querySelector(`.feature:nth-child(${sectionIndex}) .feature__content__highlight:nth-child(${(i % 3) + 1})`)
        .getBoundingClientRect()
      const hlineEndRect = document
        .querySelector(`.feature:nth-child(${sectionIndex}) .feature__content__media`)
        .getBoundingClientRect()
      this.drawLine(
        `hline${startId + i}`,
        'horizontal',
        hlineStartRect.x + hlineStartRect.width + 12 + scrollLeft,
        hlineStartRect.y + 12 + scrollTop,
        hlineEndRect.x + scrollLeft,
        hlineEndRect.y + hlineEndRect.height / 2 + scrollTop,
        window.innerWidth < BREAKPOINTS.VIEWPORT_L
      )
    }
  }

  drawOddSectionLines(startId, sectionIndex) {
    const scrollLeft = PrototypePage.getScrollLeft()
    const scrollTop = PrototypePage.getScrollTop()

    for (let i = 0; i < 3; i++) {
      const hlineStartRect = document
        .querySelector(`.feature:nth-child(${sectionIndex}) .feature__content__media`)
        .getBoundingClientRect()
      const hlineEndRect = document
        .querySelector(`.feature:nth-child(${sectionIndex}) .feature__content__highlight:nth-child(${(i % 3) + 1})`)
        .getBoundingClientRect()
      this.drawLine(
        `hline${startId + i}`,
        'horizontal',
        hlineStartRect.x + hlineStartRect.width + scrollLeft,
        hlineStartRect.y + hlineStartRect.height / 2 + scrollTop,
        hlineEndRect.x + scrollLeft - 16,
        hlineEndRect.y + scrollTop + 12,
        window.innerWidth < BREAKPOINTS.VIEWPORT_L
      )
    }
  }

  drawVerticalSectionLines() {
    const scrollLeft = PrototypePage.getScrollLeft()
    const scrollTop = PrototypePage.getScrollTop()

    for (let i = 1; i <= 3; i++) {
      const vlineStartRect = document
        .querySelector(`.feature:nth-child(${i}) .feature__content__media`)
        .getBoundingClientRect()
      const vlineEndRect = document
        .querySelector(`.feature:nth-child(${i + 1}) .feature__header__icon`)
        .getBoundingClientRect()
      this.drawLine(
        `vline${i + 1}`,
        'vertical',
        vlineStartRect.x + vlineStartRect.width / 2 + scrollLeft,
        vlineStartRect.y + vlineStartRect.height + scrollTop,
        vlineEndRect.x + vlineEndRect.width / 2 + scrollLeft,
        vlineEndRect.y + scrollTop - 16,
        window.innerWidth < BREAKPOINTS.VIEWPORT_L
      )
    }
  }

  render() {
    if (!this.pageLoaded) return

    const scrollLeft = PrototypePage.getScrollLeft()
    const scrollTop = PrototypePage.getScrollTop()

    // Line 1
    const hline1EndRect = document.querySelector('.hero__title__arrow--left').getBoundingClientRect()
    this.drawLine('hline1', 'horizontal', 0, 104, hline1EndRect.x + scrollLeft - 16, hline1EndRect.y + scrollTop - 5)

    // Line 2
    const hline2StartRect = document.querySelector('.hero__title__arrow--right').getBoundingClientRect()
    const hline2EndRect = document.querySelector('.hero__title').getBoundingClientRect()
    const hline2Height = window.innerWidth < BREAKPOINTS.VIEWPORT_L ? 30 : 60
    this.drawLine(
      'hline2',
      'horizontal',
      hline2StartRect.x + scrollLeft + 12,
      hline2StartRect.y + scrollTop,
      document.documentElement.clientWidth - 7,
      hline2EndRect.y + hline2EndRect.height + scrollTop + hline2Height
    )

    this.drawOddSectionLines(3, 1)
    this.drawEvenSectionLines(6, 2)
    this.drawOddSectionLines(9, 3)
    this.drawEvenSectionLines(12, 4)

    // Vertical Line 1
    const vline1StartRect = document.querySelector(`.hero__example:nth-child(2)`).getBoundingClientRect()
    const vline1EndRect = document.querySelector('.feature:nth-child(1) .feature__header__icon').getBoundingClientRect()
    this.drawLine(
      'vline1',
      'vertical',
      vline1StartRect.x + vline1StartRect.width / 2 + scrollLeft,
      vline1StartRect.y + vline1StartRect.height + scrollTop,
      vline1EndRect.x + vline1EndRect.width / 2 + scrollLeft,
      vline1EndRect.y + scrollTop - 16,
      window.innerWidth < BREAKPOINTS.VIEWPORT_L
    )

    this.drawVerticalSectionLines()
  }

  displayIframe() {
    this.iframeContainerTarget.classList.add('is-loaded')
  }
}
